module.exports = __webpack_public_path__ + "static/media/icons_sketch_map.6236824f.svg";